<template>
  <sheet-modal
    :visible="visible"
    :title="title"
    @close="handleClose"
  >
    <view class="modal-content" v-if="html" v-html="html"></view>
    <view class="modal-content" v-else>
      <slot name="fallback" />
    </view>
  </sheet-modal>
</template>

<script setup lang="ts">
import SheetModal from '@/components/sheet-modal/index.vue';

defineProps<{
  visible: boolean;
  title: string;
  html?: string;
}>();

const emit = defineEmits<{
  (e: 'close'): void;
}>();

const handleClose = () => {
  emit('close');
};
</script>

<style lang="scss" scoped>
.modal-content {
  max-height: 60vh;
  overflow-y: auto;
  font-family: 'Noto Sans SC', 'Noto Sans SC', sans-serif;
  font-weight: 500;
  font-size: 28rpx;
  color: #000000;
  line-height: 44rpx;
  padding-bottom: 20rpx;
}
</style>
